const fileName = (product, extension, string) => {
	const date = new Date();
	
	const versionByDate = date.toISOString().replace(/[:.]/g, '-').replace('T', '_').substr(0, 19);
	
	let nameString = `(${product.productSKY})_${product.variantName}_${product.productName}_${versionByDate}${
		string ? `__${string}` : ''
	}.${extension}`
	
	nameString = nameString.toLowerCase()
	nameString = nameString.replace(/-/g, '')
	nameString = nameString.replace(/ /g, '-')
	
	return nameString
	//return `(${product.productSKY})_${product.variantName}_${product.productName}.${extension}`.toLowerCase().replace(/-/g, '').replace(/ /g, '-');
}

export default fileName
